"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagInputControl = void 0;
const react_1 = __importStar(require("react"));
const ArrowIcon_1 = require("../../../../ArrowIcon");
const public_1 = require("../../../../common/public");
const Tag_1 = require("../Tag/Tag");
const helpers_1 = require("../../../../helpers");
const InputControl_1 = require("../../../helpers/InputControl");
const TagInputControl_styles_1 = require("./TagInputControl.styles");
exports.TagInputControl = (0, helpers_1.createUIElement)('TagInputControl', (_a, ref) => {
    var { className, placeholder, value, searchTerm = '', size, maxNumberOfLines, opened, error, disabled, focused, active, canAdd, hasSuggest = true, data, onRequestOpen, onRequestClose, onChange: onExternalChangeHandler, onSearch, inputError, validateNewTag, hasEnterKeyStopPropagation, hasBlurEnter = false, hasBorder = true, onFocus, onBlur: onBlurHandler, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style, onClick } = _a, rest = __rest(_a, ["className", "placeholder", "value", "searchTerm", "size", "maxNumberOfLines", "opened", "error", "disabled", "focused", "active", "canAdd", "hasSuggest", "data", "onRequestOpen", "onRequestClose", "onChange", "onSearch", "inputError", "validateNewTag", "hasEnterKeyStopPropagation", "hasBlurEnter", "hasBorder", "onFocus", "onBlur", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style", "onClick"]);
    const valueState = (0, helpers_1.useStateValue)(value, [value]);
    const receivedValueState = (0, react_1.useMemo)(() => valueState.getValue(), [valueState]);
    const handleOnChange = (0, react_1.useCallback)((value) => {
        onSearch === null || onSearch === void 0 ? void 0 : onSearch(value || '');
        onRequestOpen === null || onRequestOpen === void 0 ? void 0 : onRequestOpen();
    }, [onRequestOpen, onSearch]);
    const searchTermState = (0, helpers_1.useStateValue)(searchTerm, [searchTerm], {
        onChange: handleOnChange
    });
    const inputRef = (0, react_1.useRef)(null);
    const scrollableRef = (0, react_1.useRef)(null);
    const hasInputControl = (0, react_1.useMemo)(() => canAdd || hasSuggest, [canAdd, hasSuggest]);
    const receivedSearchTermStateValue = (0, react_1.useMemo)(() => searchTermState.getValue(), [searchTermState]);
    const canApplySearchTerm = (0, react_1.useMemo)(() => receivedSearchTermStateValue &&
        (canAdd || (data === null || data === void 0 ? void 0 : data.includes(receivedSearchTermStateValue))), [canAdd, data, receivedSearchTermStateValue]);
    const handleInputFocus = (0, react_1.useCallback)(() => {
        if (hasInputControl && inputRef && inputRef.current) {
            inputRef.current.focus();
        }
    }, [hasInputControl]);
    const onInternalChangeHandler = (0, react_1.useCallback)((nextValue, shouldScrollToBottom = true) => {
        onExternalChangeHandler === null || onExternalChangeHandler === void 0 ? void 0 : onExternalChangeHandler(nextValue);
        if (shouldScrollToBottom) {
            setTimeout(() => {
                // We need scroll to after external state provides new value
                if (scrollableRef.current) {
                    scrollableRef.current.scrollTop = scrollableRef.current.scrollHeight;
                }
            }, 50);
        }
    }, [onExternalChangeHandler]);
    const handleOnBlur = (0, react_1.useCallback)(() => {
        onBlurHandler === null || onBlurHandler === void 0 ? void 0 : onBlurHandler();
    }, [onBlurHandler]);
    const handleInputOnChange = (0, react_1.useCallback)((event) => {
        searchTermState.setValue(event.target.value || '');
    }, [searchTermState]);
    const validateAndChangeValue = (0, react_1.useCallback)(() => {
        var _a;
        const isValueValid = (_a = validateNewTag === null || validateNewTag === void 0 ? void 0 : validateNewTag(receivedSearchTermStateValue)) !== null && _a !== void 0 ? _a : true;
        if (!isValueValid) {
            return;
        }
        searchTermState.setValue('');
        onInternalChangeHandler === null || onInternalChangeHandler === void 0 ? void 0 : onInternalChangeHandler([...receivedValueState, receivedSearchTermStateValue]);
    }, [
        onInternalChangeHandler,
        receivedSearchTermStateValue,
        receivedValueState,
        searchTermState,
        validateNewTag
    ]);
    const handleInputOnKeyPress = (0, react_1.useCallback)((e) => {
        if (e.code === 'Enter' && canApplySearchTerm) {
            validateAndChangeValue();
        }
    }, [canApplySearchTerm, validateAndChangeValue]);
    const handleInputOnKeyDown = (0, react_1.useCallback)((e) => {
        if (e.code === 'Backspace' &&
            receivedValueState.length &&
            !receivedSearchTermStateValue) {
            e.stopPropagation();
            onInternalChangeHandler === null || onInternalChangeHandler === void 0 ? void 0 : onInternalChangeHandler(receivedValueState.slice(0, receivedValueState.length - 1));
        }
    }, [onInternalChangeHandler, receivedSearchTermStateValue, receivedValueState]);
    const handleInputOnBlur = (0, react_1.useCallback)(() => {
        if (hasBlurEnter && canApplySearchTerm) {
            validateAndChangeValue();
        }
        onBlurHandler === null || onBlurHandler === void 0 ? void 0 : onBlurHandler();
    }, [canApplySearchTerm, hasBlurEnter, onBlurHandler, validateAndChangeValue]);
    const onToggleControlClick = (0, react_1.useCallback)(() => {
        handleInputFocus();
        opened ? onRequestClose === null || onRequestClose === void 0 ? void 0 : onRequestClose() : onRequestOpen === null || onRequestOpen === void 0 ? void 0 : onRequestOpen();
    }, [handleInputFocus, onRequestClose, onRequestOpen, opened]);
    const toggleControl = (0, react_1.useMemo)(() => hasSuggest
        ? [
            {
                icon: react_1.default.createElement(ArrowIcon_1.ArrowIcon, { direction: public_1.ARROW_DIRECTION.down }),
                active: opened,
                onClick: onToggleControlClick
            }
        ]
        : undefined, [hasSuggest, onToggleControlClick, opened]);
    const handleTagRemove = (0, react_1.useCallback)((e, tag) => {
        e.stopPropagation();
        if (!disabled) {
            onInternalChangeHandler === null || onInternalChangeHandler === void 0 ? void 0 : onInternalChangeHandler(receivedValueState.filter((i) => i !== tag), false);
        }
    }, [disabled, onInternalChangeHandler, receivedValueState]);
    const tagError = (0, react_1.useMemo)(() => error && !inputError, [error, inputError]);
    const tags = (0, react_1.useMemo)(() => receivedValueState.map((tag, idx) => (react_1.default.createElement(Tag_1.Tag, { key: `${tag}:${idx}`, title: tag, disabled: disabled, error: tagError, onRemove: (e) => handleTagRemove(e, tag) }))), [disabled, handleTagRemove, receivedValueState, tagError]);
    const inputPlaceholder = (0, react_1.useMemo)(() => (receivedValueState.length === 0 ? placeholder : undefined), [placeholder, receivedValueState.length]);
    const inputWidth = (0, react_1.useMemo)(() => receivedSearchTermStateValue
        ? `${Math.max(receivedSearchTermStateValue.length + 2, 6)}ch`
        : undefined, [receivedSearchTermStateValue]);
    const input = (0, react_1.useMemo)(() => hasInputControl && (react_1.default.createElement(InputControl_1.InputControl, { ref: inputRef, key: "input-control", placeholder: inputPlaceholder, onChange: handleInputOnChange, value: receivedSearchTermStateValue, hasEnterKeyStopPropagation: hasEnterKeyStopPropagation, onKeyEnterPress: handleInputOnKeyPress, onKeyDown: handleInputOnKeyDown, onBlur: handleInputOnBlur, error: error && inputError, width: inputWidth, height: "22px", disabled: disabled })), [
        hasInputControl,
        inputPlaceholder,
        handleInputOnChange,
        receivedSearchTermStateValue,
        hasEnterKeyStopPropagation,
        handleInputOnKeyPress,
        handleInputOnKeyDown,
        handleInputOnBlur,
        error,
        inputError,
        inputWidth,
        disabled
    ]);
    const isActive = (0, react_1.useMemo)(() => opened || active, [active, opened]);
    const handleOnClick = (0, react_1.useCallback)((e) => {
        handleInputFocus();
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }, [handleInputFocus, onClick]);
    return (react_1.default.createElement(TagInputControl_styles_1.StyledTagInputControl, Object.assign({}, rest, { buildIn: !hasBorder, isCompact: !hasBorder, "data-selector-id": rest['data-selector-id'], className: (0, helpers_1.cn)('vm-TagInputControl', className), scrollableRef: scrollableRef, size: size, isDisabled: disabled, hasError: error, partialError: inputError, hasSpacing: false, maxRows: maxNumberOfLines, isFocused: focused, isActive: isActive, onClick: handleOnClick, onFocus: onFocus, onBlur: handleOnBlur, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, actions: toggleControl, "data-focused": focused, ref: ref, style: style }),
        react_1.default.createElement(TagInputControl_styles_1.StyledTagInputControlWrapper, { hasSpacing: hasBorder },
            tags.map((tag) => tag),
            input)));
});
//# sourceMappingURL=TagInputControl.js.map